module.exports = __webpack_public_path__ + "img/Tree.4b34274b.png";